import { FC } from 'react';

import { Typography } from '@mui/material';
import { Box } from '@mui/system';

import FulfilmentHistory from '@/shared/types/fulfilment/history.type';
import formatDate from '@/shared/utils/formatDate';

import Details from './components/Details';
import StatusIndicator from './components/StatusIndicator';

type HistoryItemProps = {
  historyItem: FulfilmentHistory;
};

const HistoryItem: FC<HistoryItemProps> = ({ historyItem }) => {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'repeat(3, auto)',
        alignItems: 'flex-start',
        gap: 1,
      }}
    >
      <StatusIndicator status={historyItem.status} />
      <Details historyItem={historyItem} />
      <Typography variant='caption' color='text.secondary'>
        {formatDate(historyItem.ts_modified)}
      </Typography>
    </Box>
  );
};

export default HistoryItem;
